
import Vue from 'vue'
import axios from 'axios'
import { Component } from 'vue-property-decorator'
import { downloadFile } from '../../global/functions/util'
import { TranslationActivity, TranslationActivityFile, TranslationActivitySource } from '../../global/models'

@Component
export default class TranslationSourceModal extends Vue {
  activity: TranslationActivity | null = null

  show = false

  isLoading = true

  sources: TranslationActivitySource[] = []

  expandedSources: { [key: string]: boolean } = {}
  
  get atLeastTwoVisible() {
    return this.sources.reduce((visibleCount, source) => {
      return visibleCount + (source.isIncludedInExtract ? 1 : 0)
    }, 0) >= 2
  }

  open(activity: TranslationActivity) {
    this.activity = activity
    this.getSources()
    this.show = true
  }

  close() {
    this.activity = null
    this.show = false
  }

  async getSources() {
    if (!this.activity) {
      return
    }
    const response = await axios.get<TranslationActivitySource[]>(`/jobs/${this.activity.jobId}/activities/${this.activity.id}/sources`)
    this.sources = response.data
    this.sources.forEach((source) => {
      if (this.expandedSources[source.id] === undefined) {
        this.expandedSources = { ...this.expandedSources, [source.id]: false }
      }
    })
    this.isLoading = false
  }

  async toggleSourceVisibility(source: TranslationActivitySource) {
    if (!this.activity) {
      return
    }
    try {
      await axios.put(`/jobs/${this.activity.jobId}/activities/${this.activity.id}/sources/${source.id}`, { isIncludedInExtract: !source.isIncludedInExtract })
      const index = this.sources.findIndex(s => s.id === source.id)
      this.sources.splice(index, 1, { ...source, isIncludedInExtract: !source.isIncludedInExtract })
      this.$store.dispatch('success', 'Updated document visibility successfully')
    } catch (err) {
      this.$store.dispatch('error', 'Error updating document visibility')
    }
  }

  async toggleSourceImageVisibility(image: TranslationActivityFile) {
    if (!this.activity) {
      return
    }
    try {
      await axios.put(`/jobs/${this.activity.jobId}/activities/${this.activity.id}/sources/${image.sourceId}/images/${image.id}`, { isIncludedInExtract: !image.isIncludedInExtract })
      const source = this.sources.find(s => s.id === image.sourceId)
      if (!source) {
        return
      }
      const index = source.images.findIndex(i => i.id === image.id)
      source.images.splice(index, 1, { ...image, isIncludedInExtract: !image.isIncludedInExtract })
      this.$store.dispatch('success', 'Updated document visibility successfully')
    } catch (err) {
      this.$store.dispatch('error', 'Error updating document visibility')
    }
  }

  toggleImageDisplay(source: TranslationActivitySource) {
    this.$set(this.expandedSources, source.id, !this.expandedSources[source.id])
  }

  downloadDocument(source: TranslationActivitySource) {
    downloadFile(source.path)
  }

  atLeastTwoImagesVisible(source: TranslationActivitySource) {
    return source.images.reduce((visibleCount, image) => {
      return visibleCount + (image.isIncludedInExtract ? 1 : 0)
    }, 0) >= 2
  }
}
